import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './UsersList.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";
import { Col, Container, Form, Row } from "react-bootstrap";
import useAuth from "../../hooks/useAuth";


const ListFranchises = () => {
  const { auth } = useAuth();
  const handleRedirect = () => {
    navigate("/createfranchise");
  }
  const [franchises, setFranchises] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const franchisesPerPage = 10;
  const axiosPrivate = useAxiosPrivate();
  const FRANCHISES_URL = "api/list-franchises";
  const navigate = useNavigate();

  const [businesstypes, setBusinesstypes] = useState([]);
  const [selectedBusinesstype, setSelectedBusinesstype] = useState("");


  const fetchFranchises = useCallback(async () => {
    try {
      // Build URL conditionally
      const url = auth?.franchise_id
        ? `${FRANCHISES_URL}?parent_franchise_id=${auth.franchise_id}`
        : FRANCHISES_URL;

      const response = await axiosPrivate.get(url, {
        withCredentials: true,
      });

      setFranchises(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Franchise:", error);
      setError(error?.response?.data?.message || "Failed to load franchises");
      setLoading(false);
    }
  }, [axiosPrivate, auth?.parent_franchise_id]);

  useEffect(() => {
    const fetchBusinesstypes = async () => {
      try {
        let excludeTypes = [];

        if (auth?.business_type === "MBA") {
          excludeTypes = ["MBA"];
        } else if (auth?.business_type === "RO") {
          excludeTypes = ["MBA", "RO"];
        } else if (auth?.business_type === "BA") {
          excludeTypes = ["MBA", "RO", "BA"];
        }

        const query =
          excludeTypes.length > 0
            ? `?exclude_types=${excludeTypes.join(",")}`
            : "";

        const res = await axiosPrivate.get(
          `/api/list-businesstypes${query}`
        );

        // ❌ Remove Head Office (HO)
        const filtered = res.data.filter(
          (item) => item.value !== "HO"
        );

        setBusinesstypes(filtered);
      } catch (error) {
        console.error("Failed to load businesstypes", error);
      }
    };

    fetchBusinesstypes();
  }, [auth?.business_type]);

  const handleViewClick = (franchiseId) => {
    // Navigate to the GetFranchise component with franchiseId as a URL parameter
    navigate(`/GetFranchise/${franchiseId}`);
  };
  const handleEditClick = (franchiseId) => {
    navigate(`/UpdateFranchise/${franchiseId}`);
  };

  useEffect(() => {
    fetchFranchises();
  }, [fetchFranchises]);

  const indexOfLastFranchise = currentPage * franchisesPerPage;
  const indexOfFirstFranchise = indexOfLastFranchise - franchisesPerPage;
  // const currentFranchise = franchises.slice(indexOfFirstFranchise, indexOfLastFranchise);

  // Filter franchises based on selected business type
  const filteredFranchises = selectedBusinesstype
    ? franchises.filter(
      (franchise) =>
        franchise.business_type === selectedBusinesstype
    )
    : franchises;

  // Pagination on filtered data
  const currentFranchise = filteredFranchises.slice(
    indexOfFirstFranchise,
    indexOfLastFranchise
  );






  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // const totalPages = Math.ceil(franchises.length / franchisesPerPage);

  const totalPages = Math.ceil(
    filteredFranchises.length / franchisesPerPage
  );

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <>
      {/* <Container> */}
      <section className="empbody">
        <div className="wrapperemp2">
          <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create Franchise</button>
          <h3>Franchise List</h3>


          <div className=" input-boxs">
            <label htmlFor="businessType">Business Type </label>

            <select
              className="newregselect"
              value={selectedBusinesstype}
              // onChange={(e) => setSelectedBusinesstype(e.target.value)}
              onChange={(e) => {
                setSelectedBusinesstype(e.target.value);
                setCurrentPage(1);
              }}
            >
              <option value="">Select Business Type</option>

              {businesstypes.map((businesstype) => (
                <option key={businesstype.value} value={businesstype.value}>
                  {businesstype.text} ({businesstype.value})
                </option>
              ))}
            </select>




          </div>
          <table id="customers">
            <thead>
              <tr>
                <th>Franchise Id</th>
                <th>Parent Franchise</th>
                <th>Franchise</th>
                <th>Type</th>
                <th>Mobile</th>
                <th>Email</th>
                <th>Contact Person</th>
                <th>Options</th>
              </tr>
            </thead>
            <tbody>
              {/* {franchises.length === 0 ? ( */}

              {
                filteredFranchises.length === 0 ? (
                  <tr><td colSpan="6">No franchises available.</td></tr>
                ) : (
                  currentFranchise.map(franchise => (
                    <tr key={franchise.franchise_id}>
                      <td>{franchise.franchise_id}</td>
                      <td>
                        {franchise.parent_franchise_code || franchise.parent_franchise_name ? (
                          <>
                            (<b>{franchise.parent_franchise_code || "-"}</b>) -{" "}
                            {franchise.parent_franchise_name || "-"}
                          </>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>(<b>{franchise.franchise_code}</b>) - {franchise.franchise_name}</td>
                      <td>{franchise.business_type}</td>
                      <td>{franchise.mobile}</td>
                      <td>{franchise.email}</td>
                      <td>{franchise.contact_person}</td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-primary button-space btn-ico"
                          onClick={() => handleViewClick(franchise.franchise_id)}
                        >
                          <i className="bx bxs-show icon"></i>
                        </button>
                        <button type="button" className="btn btn-warning btn-ico" onClick={() => handleEditClick(franchise.franchise_id)}>
                          <i className="bx bxs-edit icon"></i>

                        </button>
                      </td>
                    </tr>
                  ))
                )}
            </tbody>

          </table>

          {totalPages > 1 && (
            <div className="pagination">
              <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  onClick={() => handlePageChange(index + 1)}
                  disabled={currentPage === index + 1}
                >
                  {index + 1}
                </button>
              ))}
              <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
            </div>
          )}
        </div>
      </section>
      <TopBar />
      {/* </Container> */}
    </>
  );
};

export default ListFranchises;
